import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './shared/guards/auth/auth.guard';
import { SipGuard } from './shared/guards/sip/sip.guard';
// import { HfGuard } from './shared/guards/health-first/health-first.guard';

const routes: Routes = [
  /*Redirect old php to new sac*/
  {
    path: 'campaign/start_new_campaign.php',
    redirectTo: 'new/crowdfunding/medical'
  },
  {
    path: 'new/campaign/new',
    redirectTo: 'new/crowdfunding/medical'
  },
  {
    path: 'new/browse',
    redirectTo: 'crowdfunding/fundraisers'
  },
  {
    path: 'new/login',
    loadComponent: () => import('./pages/auto-redirect/auto-redirect.component').then((c) => c.AutoRedirectComponent),
    data: {
      page_name: 'auto_redirect',
      category: 'redirect url',
      skipLastOrder: true
    }
  },
  {
    path: 'new/crowdfunding',
    loadChildren: () => import('./pages/create-campaign/create-campaign.routes').then(r => r.CreateCampainRoutes),
  },
  {
    path: 'new/campaign-thank-you',
    loadComponent: () => import('./pages/campaign-create-thankyou/campaign-create-thankyou.component').then(c => c.CampaignCreateThankyouComponent),
    data: {
      page_name: 'campaign_thank_you',
      category: 'start fundraiser',
      skipLastOrder: true
    }
  },
  {
    path: 'new/logout',
    loadComponent: () => import('./pages/logout/logout.component').then(c => c.LogoutComponent)
  },
  {
    path: 'new/user/account',
    loadComponent: () => import('./pages/login-via-token/login-via-token.component').then(c => c.LoginViaTokenComponent)
  },
  {
    path: 'new/payment-route',
    loadComponent: () => import('./pages/payment-routing/payment-routing.component').then(c => c.PaymentRoutingComponent),
    data: {
      page_name: 'payment-redirect-page',
      category: 'payment',
      skipLastOrder: true
    }
  },
  {
    path: 'new/show-widget/:tag',
    loadComponent: () => import('./pages/show-widget/show-widget.component').then((c) => c.ShowWidgetComponent),
    data: {
      page_name: 'show_widget'
    }
  },
  {
    path: 'new/access',
    loadComponent: () => import('./pages/token-login/token-login.component').then(c => c.TokenLoginComponent),
    data: {
      page_name: 'token_login'
    }
  },
  {
    path: 'new/test',
    loadComponent: () => import('./pages/test/test.component').then(c => c.TestComponent),
    data: {
      page_name: 'test_page'
    }
  },
  {
    path: 'new/saf',
    loadComponent: () => import('./pages/saf/saf.component').then(c => c.SafComponent),
    data: {
      page_name: 'new_saf',
      skipLastOrder: true
    }
  },
  {
    path: '',
    loadComponent: () => import('./layout/layout.component').then(c => c.LayoutComponent),
    children: [
      {
        path: 'new/access-denied',
        loadComponent: () => import('./pages/access-denied/access-denied.component').then(c => c.AccessDeniedComponent)
      },
      {
        path: 'new/anniversary',
        loadComponent: () => import('./pages/anniversary/anniversary.component').then(c => c.AnniversaryComponent),
        data: {
          page_name: 'anniversary',
          category: 'anniversary',
          sip: true
        }
      },
      {
        path: 'crowdfunding/fundraisers',
        loadComponent: () => import('./pages/browse-campaign/browse-campaign.component').then(c => c.BrowseCampaignComponent),
        data: {
          page_name: 'browse_fundraiser',
          category: 'crowdfunding'
        }
      },
      {
        path: 'deardoctor',
        loadComponent: () => import('./pages/dear-doctor/dear-doctor.component').then(c => c.DearDoctorComponent),
        data: {
          page_name: 'dear_doctor'
        }
      },
      {
        path: 'payment-failed',
        loadComponent: () => import('./pages/payment-failed/payment-failed.component').then((c) => c.PaymentFailedComponent),
        data: {
          page_name: 'payment_failed',
          skip_last_order: true
        }
      },
      {
        path: 'new/campaign-review-page',
        loadComponent: () => import('./pages/saf-review/saf-review.component').then(c => c.SafReviewComponent)
      },
      {
        path: 'new/referral',
        loadComponent: () => import('./pages/referral/referral.component').then(c => c.ReferralComponent),
        data: {
          page_name: 'impact_portfolio_refer',
          category: 'portfolio',
          sip: true
        }
      },
      {
        path: 'new/standalonetip',
        loadChildren: () => import('./standalone-tip/standalone-tip.module').then(m => m.StandaloneTipModule)
      },
      {
        path: 'fundraiser',
        loadChildren: () => import('./fundraiser/fundraiser.module').then(m => m.FundraiserModule)
      },
      {
        path: 'supportfundraiser',
        loadChildren: () => import('./support-fundraiser/support-fundraiser.module').then(m => m.SupportFundraiserModule)
      },
      {
        path: 'stories/savealife',
        loadChildren: () => import('./story-list/story-list.module').then(m => m.StoryListModule)
      },
      {
        path: 'stories/lg',
        loadChildren: () => import('./leadgenpage/leadgenpage.module').then(m => m.LeadgenPageModule)
      },
      {
        path: 'stories',
        loadChildren: () => import('./story/story.module').then(m => m.StoryModule)
      },
      {
        path: 'new/stories',
        loadChildren: () => import('./story-v3/story-v3.module').then(m => m.StoryV3Module)
      },
      {
        path: 'new/signin',
        loadChildren: () => import('./sign-in/sign-in.module').then(m => m.SignInModule)
      },
      {
        path: 'new/kettokart/thankyou',
        loadChildren: () => import('./thankyou-page/thankyou-page.module').then(m => m.ThankyouPageModule)
      },
      {
        path: 'new/thankyou',
        loadChildren: () => import('./thankyou-page/thankyou-page.module').then(m => m.ThankyouPageModule)
      },
      {
        path: 'new/pledge-more',
        canActivate: [AuthGuard],
        loadChildren: () => import('./common/pledge-page/pledge-page.module').then(m => m.PledgePageModule)
      },
      {
        path: 'new/404',
        loadComponent: () => import('./pages/pagenotfound/pagenotfound.component').then(c => c.PagenotfoundComponent),
      },
      {
        path: 'new/campaign/campaign_update',
        loadChildren: () => import('./update-page/update-page.module').then(m => m.UpdatePageModule)
      },
      {
        path: 'new/campaign_created',
        loadChildren: () => import('./non-med-thankyou/non-med-thankyou.module').then(m => m.NonMedThankyouModule)
      },
      {
        path: 'crowdfunding',
        loadChildren: () => import('./how-it-works/how-it-works.module').then(m => m.HowItWorksModule)
      },
      {
        path: 'medical-finance-loans',
        loadChildren: () => import('./medical-finance-loans/medical-finance-loans.module').then(m => m.MedicalFinanceLoansModule)
      },
      {
        path: 'new/press-club',
        loadComponent: () => import('./common/press-club/press-club.component').then(m => m.PressClubComponent),
      },
      {
        path: 'new/insurance',
        loadComponent: () => import('./pages/insurance-page/insurance-page.component').then(c => c.InsurancePageComponent),
        data: {
          page_name: 'insurance_page',
          category: 'insurance',
          skipLastOrder: true
        }
      },
      {
        path: 'new/twfbaahubaliauction',
        loadChildren: () => import('./static-pages/static-pages.module').then(m => m.StaticPagesModule)
      },
      {
        path: 'new/portfolio/welcome',
        loadChildren: () => import('./impact-landing/impact-landing.module').then(m => m.ImpactLandingModule)
      },
      {
        path: 'new/portfolio/v2',
        canActivate: [AuthGuard, SipGuard],
        runGuardsAndResolvers: 'always',
        loadChildren: () => import('./portfolio-v3/portfolio-v3.module').then(m => m.PortfolioV3Module),
        data: {
          page_name: 'sip_portfolio_v2'
        }
      },
      {
        path: 'new/portfolio',
        canActivate: [AuthGuard, SipGuard],
        runGuardsAndResolvers: 'always',
        loadChildren: () => import('./portfolio-v3/portfolio-v3.module').then(m => m.PortfolioV3Module)
      },
      {
        path: 'cause',
        loadChildren: () => import('./medical-fundraising/medical-fundraising.module').then(m => m.MedicalFundraisingModule)
      },
      {
        path: 'new/payment',
        loadChildren: () => import('./common/payment/payment.module').then(m => m.PaymentModule)
      },
      {
        path: 'new/about/about-us',
        loadChildren: () => import('./team/team.module').then(m => m.TeamModule)
      },
      {
        path: 'new/sip-upi',
        loadChildren: () => import('./sip-upi-intent/sip-upi-intent.module').then(m => m.SipUpiIntentModule)
      },
      {
        path: 'new/success-stories',
        loadChildren: () => import('./success-stories/success-stories.module').then(m => m.SuccessStoriesModule),
      },
      {
        path: 'new/sip-onetime-onboard',
        loadChildren: () => import('./sip-onetime-onboard/sip-onetime-onboard.module').then(m => m.SipOnetimeOnboardModule)
      },
      {
        path: 'new/sip/wallet-recharge',
        canActivate: [AuthGuard],
        runGuardsAndResolvers: 'always',
        loadChildren: () => import('./wallet-recharge/wallet-recharge.module').then(m => m.WalletRechargeModule)
      },
      {
        path: 'new/sip/welcome',
        loadChildren: () => import('./non-card-v3/non-card-v3.module').then(m => m.NonCardV3Module)
      },
      {
        path: 'new/sip-portfolio-page',
        canActivate: [AuthGuard],
        loadChildren: () => import('./common/sip-thankyou-first/sip-thankyou-first.module').then(m => m.SipThankyouFirstModule)
      },
      {
        path: 'new/sip/payment-standalone',
        canActivate: [AuthGuard],
        runGuardsAndResolvers: 'always',
        loadChildren: () => import('./sip-payment-standalone/sip-payment-standalone.module').then(m => m.SipPaymentStandaloneModule)
      },
      {
        path: 'new/sip/change-payment',
        loadChildren: () => import('./payment-sip/payment-sip.module').then(m => m.ChangePaymentSipModule)
      },
      {
        path: 'new/dm/:cause',
        loadComponent: () => import('./pages/dm-story/dm-story.component').then(c => c.DmStoryComponent),
        data: {
          page_name: 'dm_story'
        }
      },
      {
        path: 'new/sip/:cause',
        loadComponent: () => import('./pages/cause-dm-page/cause-dm-page.component').then((c) => c.CauseDmPageComponent),
        data: {
          page_name: 'cause_dm_page'
        }
      },
      {
        path: 'new/sip/medical/v2',
        loadComponent: () => import('./pages/dm-sip-medical/dm-sip-medical.component').then((c) => c.DmSipMedicalComponent),
        data: {
          page_name: 'new_dm_page'
        }
      },
      {
        path: 'new/sip',
        loadChildren: () => import('./referral-page-v2/referral-page-v2.module').then(m => m.ReferralPageV2Module)
      },
      {
        path: 'new/cost-calculator',
        loadChildren: () => import('./medical-cost-calculator/medical-cost-calculator.module').then(m => m.MedicalCostCalculatorModule)
      },
      {
        path: 'new/sip-thankyou',
        loadChildren: () => import('./common/onboarding-sip-v1/onboarding-sip-v1.module').then(m => m.OnboardingSipV1Module)
      },
      {
        path: 'new/download-page',
        loadComponent: () => import('./pages/download-page/download-page.component').then(c => c.DownloadPageComponent)
      },
      {
        path: 'hospitals',
        children: [
          {
            path: '**',
            redirectTo: '/new/404'
          }
        ]
      },
      {
        path: '',
        loadComponent: () => import('./pages/home/home.component').then((c) => c.HomeComponent),
        data: {
          title: 'Crowdfunding India - Ketto is a Crowdfunding Platform based out of India',
          page_name: 'home',
          category: 'home',
          skipLastOrder: true
        }
      }
    ]
  },
  {
    path: 'healthfirst',
    loadChildren: () => import('./pages/health-first/health-first.routes').then(r => r.HEALTH_FIRST_ROUTES),
    // canActivate: [HfGuard],
    // runGuardsAndResolvers: 'always'
  },
  {
    path: '**',
    redirectTo: '',
    pathMatch: 'full'
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {
    initialNavigation: 'enabledBlocking',
    onSameUrlNavigation: 'reload'
  })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
